import { TextHighlighter } from "@components/TextHighlighter";
import { BodySmall } from "@components/Typography";
import { useGoalFlow } from "@hooks";
import { Translations, i18n } from "@i18n";
import { calculateAgeByTargetYear } from "@utils";
import { styles } from "./styles";

type ProjectedAgeFooterProps = {
  targetYear: string;
};

export const ProjectedAgeFooter = ({ targetYear }: ProjectedAgeFooterProps) => {
  const {
    goalProps: { firstName, dateOfBirth },
  } = useGoalFlow();

  const age = calculateAgeByTargetYear({
    dateOfBirth,
    targetYear: Number(targetYear),
  });

  const text = i18n.t(Translations.AccountHorizonRouteFooter, {
    age,
    name: firstName ?? "",
  });

  return (
    <TextHighlighter
      text={text}
      words={[{ text: String(age) }]}
      TypographyComponent={BodySmall}
      style={styles.projectedAgeFooter}
    />
  );
};
